/**
 * Header component - handles animations and search functionality
 */

/**
 * Initialize header scroll animations
 */
export function initHeaderAnimations() {
	const header = document.querySelector("#site-header");

	if (!header) {
		return;
	}

	// Intersection observer on header
	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					header.classList.remove("reduced-header");
				} else {
					header.classList.add("reduced-header");
				}
			});
		},
		{
			root: null, // Use viewport as root
			// rootMargin: "-210px 0px 0px 0px",
			rootMargin: "-180px 0px 0px 0px",
			threshold: 0,
		}
	);

	// Start observing the header element
	observer.observe(header);
}
